import { useState, useEffect } from 'react';
import { Deal, fetchAllFreeGames } from '../services/deals';

export const useDeals = () => {
  const [freeGames, setFreeGames] = useState<Deal[]>([]);
  const [loadingFreeGames, setLoadingFreeGames] = useState(true);
  const [freeGamesError, setFreeGamesError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  useEffect(() => {
    fetchAllFreeGames()
      .then((result) => {
        setFreeGames(result.deals);
        setLastUpdated(result.lastUpdated);
      })
      .catch((err: Error) => {
        console.error(err);
        setFreeGamesError(err.message);
      })
      .finally(() => setLoadingFreeGames(false));
  }, []);

  return { freeGames, loadingFreeGames, freeGamesError, lastUpdated };
};
